import React from "react";
import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 text-center px-4">
      <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
      <p className="text-lg text-gray-600 mb-6">
        Oops! The page you’re looking for doesn’t exist.
      </p>
      <div className="flex gap-2">
        <button onClick={() => nav(-1)} className="btn btn-white">
          ← Go Back
        </button>
        <button onClick={() => nav("/dashboard")} className="btn btn-success">
          Dashboard
        </button>
      </div>
    </div>
  );
}
